
import {
  OrderDefault, PeriodDefault,
  QueryTypeDefault, SearchTypeDefault,
  SEARCH_SNIPPET_DEFAULT
} from "@/shared/utils/search/search.constants";

export const formatSearchParams = (searchParams) => {
  const {
    query,
    queryFull,
    books,
    chapters,
    context,
    folders,
    start,
    limit = 10,
    extras = {},
    lang,
    bookCode,
    ...rest
  } = searchParams;

  return {
    query,
    queryFull: queryFull ? queryFull : query,
    books: makeArray(books),
    chapters: chapters ? makeArray(chapters) : undefined,
    context,
    folders,
    start,
    limit,
    lang,
    bookCode,
    extras: {
      ...rest,
      ...extras,
      lang: lang ? makeArray(lang) : "",
      queryType: rest.queryType || extras.queryType || QueryTypeDefault,
    },
  };
};

const makeArray = (param) => {
  if (Array.isArray(param)) {
    return param;
  }

  return [param];
};

export const makeSearchUrlObject = (searchParams) => {
  const searchUrlObject = {};
  const { extras, ...basic } = searchParams;
  const flatSearchParams = { ...extras, ...basic };

  for (const [name, value] of Object.entries(flatSearchParams)) {
    if (value && value !== "") {
      searchUrlObject[name] = value;
    }
  }

  return searchUrlObject;
};

export const basicSearchDefault = {
  start: 0,
  limit: 10,
  extras: {
    type: SearchTypeDefault,
    period: PeriodDefault,
    snippet: SEARCH_SNIPPET_DEFAULT,
    order: OrderDefault,
  },
};
